
import { useTranslation } from "react-i18next";
const Select = (props) => {
    const { value, onChange, options } = props;
    const handleChange = (e) => {
        e.preventDefault();
        onChange(e.target.value);
    }

    const { t } = useTranslation('config');

    return <div className={'input-wrapper'}>
        <select value={value} onChange={handleChange}>
            {options.map(option => (
                <option key={option.value} value={option.value} defaultValue={option.selected} hidden={option.hidden}>
                    {t(option.text)}
                </option>
            ))}
        </select></div>;
};

Select.defaultProps = {
    option: []
}


export default Select;